// extracted by mini-css-extract-plugin
module.exports = {"caClaimantsContainer":"CaClaimants_caClaimantsContainer__khsfc","button":"CaClaimants_button__7_H8u","errorWrapper":"CaClaimants_errorWrapper__jjF2A"};